"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EReportTemplateType = exports.EReportingCapacitySource = exports.EReportingTimeType = void 0;
var EReportingTimeType;
(function (EReportingTimeType) {
    EReportingTimeType["FIXED_HOUR"] = "FIXED_HOUR";
    EReportingTimeType["TIME_RANGE"] = "TIME_RANGE";
    EReportingTimeType["MAX_HOURS"] = "MAX_HOURS";
})(EReportingTimeType = exports.EReportingTimeType || (exports.EReportingTimeType = {}));
var EReportingCapacitySource;
(function (EReportingCapacitySource) {
    EReportingCapacitySource["FROM_FIELD"] = "FROM_FIELD";
    EReportingCapacitySource["FROM_MEMBERSHIP"] = "FROM_MEMBERSHIP";
})(EReportingCapacitySource = exports.EReportingCapacitySource || (exports.EReportingCapacitySource = {}));
var EReportTemplateType;
(function (EReportTemplateType) {
    EReportTemplateType["UTILIZATION"] = "UTILIZATION";
    EReportTemplateType["STUDENT_LOAD"] = "STUDENT_LOAD";
})(EReportTemplateType = exports.EReportTemplateType || (exports.EReportTemplateType = {}));
